import React from 'react';

export function RoomCardsList() {
  return <div>RoomCardsList</div>;
}
